import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { POL_BASIC_02_Schema } from './POL_BASIC_02_Schema';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(POL_BASIC_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['PolicyAndGoals', 'getPolBasic02R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PolicyAndGoals.getPolBasic02R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      POL_BASIC_02_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.PolicyAndGoals.getPolBasic02R2,
      params
    );
  }, successOptions);
};

export const useSearch4 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(POL_BASIC_02_Schema.mapper.search4);

  const query = useQuery({
    queryKey: ['PolicyAndGoals', 'getPolCategoryR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PolicyAndGoals.getPolCategoryR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolBasic02U1,
      payload
    );
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async ({ rows, chaebun }) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.save2, {
      chaebun,
    });
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolBasic02U2,
      payload
    );
  }, options);
};
export const useSave3 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.save3);

    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolCategoryU1,
      payload
    );
  }, options);
};
export const useSave4 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.save4);
    console.log(payload);

    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolBasic02U4,
      payload
    );
  }, options);
};

export const useSave5 = (options = {}) => {
  return useSaveMutation(async ({ rows, chaebun }) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.reorder2, {
      chaebun,
    });
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.savePolBasic02U5,
      payload
    );
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.deletePolBasic02D1,
      payload
    );
  }, options);
};
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.delete2);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.deletePolCategoryD1,
      payload
    );
  }, options);
};
export const useDelete3 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, POL_BASIC_02_Schema.mapper.delete3);
    return apiRequest(
      'post1',
      Global.urls.PolicyAndGoals.deletePolBasic02D3,
      payload
    );
  }, options);
};
